import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    BooleanColumn,
    DateColumn,
    DateTimeColumn,
    FloatColumn,
    NumberColumn,
    TextColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  class LegColumn {
    constructor(legId) {
      this.Header = `Leg ${legId}`;
      this.columns = [
        new TextColumn('Mode', `leg${legId}.mode`).withExcelFormatter("number"),
        new TextColumn('Dep Loc', `leg${legId}.departure.location`),
        new DateTimeColumn('Dep Date', `leg${legId}.departure.scheduledDateTime`),
        new TextColumn('Transport', `leg${legId}.transport`),
        new TextColumn('Arr Loc', `leg${legId}.arrival.location`),
        new DateTimeColumn('Arr Date', `leg${legId}.arrival.scheduledDateTime`),
      ];
    }
  }

  return [
    new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(275)),
    new TextColumn('Class', 'mailSubClass'),
    new TextColumn('Type', 'receptacleType'),
    new TextColumn('Foc', 'formatOfContents'),
    new TextColumn('Handl Class', 'handlingClass'),
    new NumberColumn('Items', 'items'),
    new NumberColumn('Items Counted', 'itemsCounted'),
    new BooleanColumn('Expr IND', 'containsNonEMSExpressItems'),
    new BooleanColumn('Expr excl', 'containsExclusivelyRVItems'),
    new BooleanColumn('Exempt', 'exemptFromTerminalDues'),
    new BooleanColumn('Doc Ind', 'containsDespatchDoc'),
    new BooleanColumn('Dgrs Good', 'containsDangerousGoods'),
    new BooleanColumn('Not Returned', 'notToBeReturned'),
    new NumberColumn('Returned', 'returned'),
    new FloatColumn('Gross Weight', 'grossWeight'),
    new FloatColumn('Net Weight', 'netWeight'),
    new DateColumn('Accounting Date', 'accountingDate'),
    new DateTimeColumn('Close Date', 'closeDateTime'),
    new DateTimeColumn('Scan Date', 'scanDate'),
    new LegColumn('1'),
    new LegColumn('2'),
    new LegColumn('3'),
    new LegColumn('4'),
    new LegColumn('5'),
  ];
};
